/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import exchangeApi from 'apis/exchange'
import { constants } from 'apps'
import { CURRENCY_TYPE } from 'apps/constants'
import {
  CIRCEL_ARROW_DOWN_PRIMARY,
  CLOSE_BTN,
  CONNECT_WALLET_EXCHANGE,
  DISABLE_CONNECT_WALLET_EXCHANGE,
  GAME_TOKEN_KUDA,
  GAME_TOKEN_MERAH,
  UP
} from 'assets/images'
import { ResultHorseModal } from 'features/Race/components'
import { useDebounce, useReloadCurrentPage, useToggle, useUpdateEffect } from 'hooks'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { SwapETokenRequest } from 'models'
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'shared'
import { handleAsyncRequest, justNumbers } from 'utils/helper'
import SwapMERAHToKUDAModalStyled from './styled'

interface SwapMERAHToKUDAModalProps {
  onCloseButtonClick: () => void
  coinKuda: number
  coinMerah: number
}

const defaultParams: SwapETokenRequest = {
  amount: ''
}

function SwapMERAHToKUDAModal({ onCloseButtonClick, coinKuda, coinMerah }: SwapMERAHToKUDAModalProps) {
  const [params, setParams] = useState<SwapETokenRequest>(defaultParams)
  const [valueMARE, setValueInput] = useState<string>('')
  const amountInput = useDebounce<string>(valueMARE, constants.DEBOUNCE_TIME)
  const [isModalResultHorseOpen, toggleIsModalResultHorseOpen] = useToggle(false)
  const [messageError, setMessageError] = useState<string>('')
  const [titleBalace, setTitleBalance] = useState<string>('')
  const [flagButtonOk, setFlagButtonOk] = useState<boolean>(false)
  const [reInputExchange, setReInputExchange] = useState<boolean>(false)
  const [confirmSwap, setConfirmSwap] = useToggle(false)
  const [watchConnectWallet, setWatchConnectWallet] = useState<boolean>(false)
  const refInput = useRef<HTMLInputElement>(null)
  const { t } = useTranslation()

  const messageSuccess = t(`${NOTIFICATION_MESSAGE}.transferredSuccess`)
  const messageFailed = t(`${NOTIFICATION_MESSAGE}.transferredFailed`)
  const messageNotEnoughWithdraw = t(`${NOTIFICATION_MESSAGE}.notEnoughMerah`)

  const handleSearchValueChanged = (e: ChangeEvent<HTMLInputElement>) => {
    const inputCoin: any = justNumbers(e.target.value)
    setValueInput(() => inputCoin)
    const compareCoinMERAHInput = inputCoin > coinMerah

    if (compareCoinMERAHInput) {
      setValueInput((e.target.value = ''))
      setTitleBalance('warning')
      toggleIsModalResultHorseOpen(true)
      setMessageError(messageNotEnoughWithdraw)
      setReInputExchange(true)
      setWatchConnectWallet(false)
    }
    setWatchConnectWallet(false)
  }

  useEffect(() => {
    if (refInput.current?.value === '') {
      setWatchConnectWallet(true)
    }
  })

  const handleCloseConfirmSwap = () => setConfirmSwap(false)

  useUpdateEffect(() => {
    setParams({ ...params, amount: amountInput })
  }, [amountInput])

  const handleSwapMERAHToKUDA = () => {
    const cannotInputValueZero = `value does not match`
    if (Number(amountInput) === 0) {
      toggleIsModalResultHorseOpen(true)
      setTitleBalance('warning')
      setMessageError(cannotInputValueZero)
      setFlagButtonOk(false)
    } else {
      setConfirmSwap(true)
      setTitleBalance('warning')
    }
  }

  const handleOk = () => {
    if (flagButtonOk === true) {
      setConfirmSwap(false)
      useReloadCurrentPage()
    } else {
      toggleIsModalResultHorseOpen(false)
    }
  }

  const handleOkExchange = () => {
    toggleIsModalResultHorseOpen(false)
  }

  const handleOkConfirm = async () => {
    handleCloseConfirmSwap()
    const [error, result] = await handleAsyncRequest(exchangeApi.postSwapEToken(params))
    if (error) {
      setTitleBalance('failed!')
      toggleIsModalResultHorseOpen(true)
      setMessageError(messageFailed)
    }
    if (!result) return

    if (result.code === 200) {
      setWatchConnectWallet(true)
      toggleIsModalResultHorseOpen(true)
      setTitleBalance('success!')
      setMessageError(messageSuccess)
      setFlagButtonOk(true)
    }
  }

  const handleDisabledBtnConnect = useCallback(() => {
    if (valueMARE) {
      return false
    }

    return true
  }, [valueMARE])

  const handleDisableBtn = useCallback(() => {
    if (watchConnectWallet === true) {
      return true
    }

    return false
  }, [watchConnectWallet])

  return (
    <Modal>
      <SwapMERAHToKUDAModalStyled>
        <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
          <img src={CLOSE_BTN} alt='close' />
        </button>
        <div className='title-exchange d-flex justify-content-between'>
          <div className='withdraw text-uppercase'>{'exchange'}</div>
          <div className='claim'>{t(`${NOTIFICATION_MESSAGE}.getYourEHtc`)}</div>
        </div>
        <div className='merah'>
          <img src={UP} alt='' />
          <img src={GAME_TOKEN_MERAH} alt='' className='game-token-merah' />
          <input
            className='value-merah search-input flex-grow-1'
            value={valueMARE}
            placeholder='0'
            onChange={handleSearchValueChanged}
            maxLength={10}
            disabled={isModalResultHorseOpen}
          />
          <span className='value-balance'>
            {t(`${NOTIFICATION_MESSAGE}.balance`)}:
            {coinMerah > 0
              ? coinMerah
              : 0}
          </span>
          <span className='title-merah'>{CURRENCY_TYPE.MERAH}</span>
        </div>
        <div className='text-center mt-1 mb-3'>
          <img src={CIRCEL_ARROW_DOWN_PRIMARY} alt='' />
        </div>
        <div className='merah'>
          <img src={UP} alt='' />
          <img src={GAME_TOKEN_KUDA} alt='' className='game-token-merah' />
          <input
            ref={refInput}
            className='value-merah search-input flex-grow-1'
            placeholder='0'
            value={valueMARE}
            maxLength={10}
            disabled
          />
          <span className='value-balance'>
            {t(`${NOTIFICATION_MESSAGE}.balance`)}:
            {coinKuda}
          </span>
          <span className='title-merah'>{'KUDA'}</span>
        </div>
        <div className='notice-exchange text-center'>
          <div>{t(`${NOTIFICATION_MESSAGE}.exchangeRate`)}</div>
          <div>{t(`${NOTIFICATION_MESSAGE}.MERAHToKuda`)}</div>
        </div>
        <div className='btn-connect-wallet text-center'>
          <button onClick={handleSwapMERAHToKUDA} disabled={handleDisableBtn()}>
            <img
              src={handleDisabledBtnConnect() ? DISABLE_CONNECT_WALLET_EXCHANGE : CONNECT_WALLET_EXCHANGE}
              alt='btn-connect-h2h'
            />
          </button>
        </div>
      </SwapMERAHToKUDAModalStyled>
      {confirmSwap && (
        <ResultHorseModal
          toggleIsModalOpen={setConfirmSwap}
          title={titleBalace}
          onCloseButtonClick={handleCloseConfirmSwap}
          onOk={handleOkConfirm}
          message={
            <span dangerouslySetInnerHTML={{ __html: t(`${NOTIFICATION_MESSAGE}.convertMerahToKuda`, { valueMARE }) }} />
          }
        />
      )}

      {isModalResultHorseOpen && (
        <ResultHorseModal
          title={titleBalace}
          onOk={reInputExchange === true ? handleOkExchange : handleOk}
          message={messageError}
          exchangeCoin={true}
        />
      )}
    </Modal>
  )
}

export default SwapMERAHToKUDAModal
